/* eslint-disable react/prop-types */
/* eslint-disable consistent-return */
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Button as MuiButton } from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from './Button.module.css';

const Button = forwardRef(({ variant, children, style, className,simpleClassName, ignoreExistingClassNames = false,disabled, ...props }, ref,) => {
    let modifierClassName;
    let newClassName;
    if( simpleClassName === "Delete") modifierClassName = styles.deleteButton;
    else if (variant === 'primary') modifierClassName = styles.primaryButton;
    else if (variant === 'secondary')
        modifierClassName = styles.secondaryButton;
    else if (variant === 'tertiary') modifierClassName = styles.tertiaryButton;
    else if (variant === 'okButton') modifierClassName = styles.okButton;    
    else modifierClassName = styles.defaultButton;
    const computedClassName = ignoreExistingClassNames
        ? className
        : clsx(styles.button, modifierClassName, className);
     if(simpleClassName != null){
      newClassName = simpleClassName
     } else{
      newClassName= ""
     }
    
    return (
        <>
            <button {...props} className={`TableButton ${modifierClassName} ${newClassName}`} ref={ref} onClick={(e) => { if (e?.detail > 1) return; return props.onClick(e); }} style={style} disabled={disabled}>
                {children}
            </button>
            <style jsx>
                {`
                .TableButton {
                    border: 0;
                    cursor: pointer;
                    margin: 0;
                    display: inline-flex;
                    outline: 0;
                    padding: 0;
                    position: relative;
                    align-items: center;
                    user-select: none;
                    border-radius: 0;
                    vertical-align: middle;
                    -moz-appearance: none;
                    justify-content: center;
                    text-decoration: none;
                    background-color: transparent;
                    -webkit-appearance: none;
                    -webkit-tap-highlight-color: transparent;
                    color: rgba(0, 0, 0, 0.87);
                    padding: 6px 16px;
                    font-size: 0.875rem;
                    min-width: 64px;
                    box-sizing: border-box;
                    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
                    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
                    font-weight: 600;
                    line-height: 1.75;
                    border-radius: 4px;
                    letter-spacing: 0.02857em;
                    text-transform: uppercase;
                    font-size: var(--smallFontSize) !important;
                  }
                  
                  .primaryButton {
                    background: #59a385;
                    color: #fff;
                  }
                  
                  .primaryButton:hover {
                    background: #488f71;
                    color: fff;
                  }
                  
                  .defaultButton {
                    background: #d8d8d8;
                    color: #707070;
                  }
                  
                  .secondaryButton {
                    background: #fff;
                    color: #707070;
                  }
                  
                  .disabledButton {
                    box-shadow: none;
                    color: #fff;
                    background: #d8d8d8;
                  }
                  
                  .tertiaryButton {
                    background: #faa023;
                    /* background: #ffa221; */
                    color: #fff;
                  }
                  
                  .tertiaryButton:hover {
                    background: #d6891c;
                  }
                  @media (max-width: 769px) {
                    .TableButton.Delete,
                    .TableButton.Edit, 
                    .TableButton.Create.New.Zone, 
                    .TableButton.Create.New.Area,
                    .TableButton.Add.New.Driver,
                    .TableButton.Add.New.Device {
                      display: none;
                    }
                  }
                `}
            </style>
        </>
    );
},
);

Button.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary','okButton']),
    ignoreExistingClassNames: PropTypes.bool,
    simpleClassName:PropTypes.string,
};

export default Button;
